import React from 'react';
import { LockClosedIcon } from '@heroicons/react/24/outline';

const LockedChapterPage = React.forwardRef(({ chapter, lockedCount = 12, pageNumber }, ref) => {
  return (
    <div ref={ref} className="book-page">
      <div className="absolute inset-0 bg-white overflow-hidden flex flex-col">
        {/* Faded chapter header */}
        <div className="relative px-5 sm:px-6 pt-5 pb-4 bg-gray-50 border-b border-gray-100">
          <p
            className="text-[8px] sm:text-[9px] font-bold text-gray-300 uppercase tracking-widest mb-1"
            style={{ fontFamily: "'Space Mono', monospace" }}
          >
            Chapter {chapter.index + 1}
          </p>
          <h2
            className="text-sm sm:text-base font-bold text-gray-300 leading-snug"
            style={{ fontFamily: "'Sora', sans-serif" }}
          >
            {chapter.title_emoji && (
              <span className="mr-1.5 opacity-40">{chapter.title_emoji}</span>
            )}
            {chapter.title}
          </h2>
        </div>

        {/* Blurred placeholder content */}
        <div className="flex-1 px-5 sm:px-6 py-4 relative overflow-hidden">
          {/* Fake blurred text lines */}
          <div className="space-y-2 select-none" aria-hidden>
            {Array.from({ length: 12 }).map((_, i) => (
              <div
                key={i}
                className="h-2 bg-gray-100 rounded-full"
                style={{ width: `${60 + ((i * 17) % 35)}%`, opacity: 0.6 + ((i % 5) * 0.06) }}
              />
            ))}
            <div className="h-3 mt-3" />
            {Array.from({ length: 8 }).map((_, i) => (
              <div
                key={`b-${i}`}
                className="h-2 bg-gray-100 rounded-full"
                style={{ width: `${55 + ((i * 13) % 40)}%`, opacity: 0.5 + ((i % 4) * 0.08) }}
              />
            ))}
          </div>

          {/* Lock overlay */}
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-white/80 backdrop-blur-[1px]">
            <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-3">
              <LockClosedIcon className="w-6 h-6 text-gray-400" />
            </div>
            <p
              className="text-sm font-semibold text-gray-600 mb-1"
              style={{ fontFamily: "'Sora', sans-serif" }}
            >
              Full Book Only
            </p>
            <p
              className="text-[10px] text-gray-400 text-center px-8 leading-relaxed"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              This chapter and {lockedCount - 1} more are waiting for you in the complete book
            </p>
          </div>
        </div>

        {pageNumber !== undefined && (
          <div className="book-page-number">{pageNumber}</div>
        )}
      </div>
    </div>
  );
});

LockedChapterPage.displayName = 'LockedChapterPage';
export default LockedChapterPage;
